import {
  faFacebook,
  faInstagram,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { useMusicPlayerStore } from '../stores/MusicPlayerService'
export default function Footer() {
  const { isPlayerVisible } = useMusicPlayerStore()
  return (
    <footer
      id="footer"
      className={`text-sm mt-auto border-t border-neutral-200 bg-gray-300 px-4 pt-6 text-neutral-600 dark:border-neutral-800 dark:bg-gray-950 dark:text-neutral-400 ${isPlayerVisible ? 'pb-24' : 'pb-6'}`}
    >
      <div className="container mx-auto flex max-w-3xl flex-col items-center justify-between gap-4 text-center md:flex-row md:text-left">
        <div className="flex flex-col items-center gap-2 md:flex-row md:items-center">
          <img
            width={64}
            height={64}
            src="/tesseract-dark.svg"
            alt="Strangeways Developments"
            className="inline-flex h-12 w-auto items-center justify-center dark:hidden"
          />
          <img
            width={64}
            height={64}
            src="/tesseract-light.svg"
            alt="Strangeways Developments"
            className="hidden h-12 w-auto items-center justify-center dark:inline-flex"
          />
          <span className="text-xs mt-1 uppercase tracking-wide text-gray-800 dark:text-neutral-500 md:ml-3 md:mt-0">
            © {new Date().getFullYear()} strangeways.ca
          </span>
        </div>

        <p className="text-xs inline-flex items-center gap-2 rounded-full border border-blue-100 bg-blue-50 px-4 py-2 font-medium text-blue-700 shadow-sm shadow-blue-100 transition hover:border-blue-200 hover:bg-blue-100 dark:border-blue-900/60 dark:bg-blue-950/40 dark:text-blue-300 dark:shadow-none dark:hover:border-blue-700 dark:hover:bg-blue-950/70">
          <span className="hidden text-[0.7rem] uppercase tracking-[0.18em] text-blue-400 sm:inline">
            Design & build
          </span>
          <span>
            Like this site?{' '}
            <Link
              className="underline underline-offset-4"
              to="https://strangeways.dev"
              target="_blank"
            >
              We make those too!
            </Link>
          </span>
        </p>
        <p id="social" className="inline-flex items-center gap-2">
          <Link
            to="https://www.instagram.com/strangewaysstudios/"
            target="_blank"
            className="hover:text-blue-600 dark:hover:text-blue-400"
          >
            <FontAwesomeIcon size="xl" icon={faInstagram} />
          </Link>
          <Link
            to="https://www.facebook.com/strangeways.co/"
            target="_blank"
            className="hover:text-blue-600 dark:hover:text-blue-400"
          >
            <FontAwesomeIcon size="xl" icon={faFacebook} />
          </Link>
          <Link
            to="https://twitter.com/strangewaysltd"
            target="_blank"
            className="hover:text-blue-600 dark:hover:text-blue-400"
          >
            <FontAwesomeIcon size="xl" icon={faTwitter} />
          </Link>
          <Link
            to="https://www.youtube.com/@strangeways_co"
            target="_blank"
            className="hover:text-blue-600 dark:hover:text-blue-400"
          >
            <FontAwesomeIcon size="xl" icon={faYoutube} />
          </Link>
        </p>
      </div>
    </footer>
  )
}
